export var DeviceModel;
(function (DeviceModel) {
    DeviceModel["PS4"] = "PS4";
    DeviceModel["PS5"] = "PS5";
})(DeviceModel || (DeviceModel = {}));
export var IonLifecycleEvent;
(function (IonLifecycleEvent) {
    IonLifecycleEvent["Deeplink"] = "deeplink";
    IonLifecycleEvent["Resume"] = "resume";
    IonLifecycleEvent["Suspend"] = "suspend";
})(IonLifecycleEvent || (IonLifecycleEvent = {}));
//# sourceMappingURL=ion-types.js.map